var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _g2, _path0, _path1, _path10, _path11, _g3, _path12, _path13, _path14, _path15, _g4, _path16, _path17, _path18, _path19, _g5, _path20, _path21, _path22, _path23, _g6, _path24, _path25, _path26, _path27, _g7, _path28, _path29, _path30, _path31, _g8, _path32, _path33, _path34, _path35, _g9, _path36, _path37, _path38, _path39, _g0, _path40, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg30Users(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 189,
    viewBox: "0 0 229 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M211.889 78.0463C207.092 46.6457 187.423 8.06775 148.565 4.03054C148.565 4.03054 119.062 0.441974 89.9785 5.8808C72.7175 9.10877 57.5821 18.7177 48.005 32.5281C38.4278 46.3385 35.2288 63.1785 39.1112 79.2334C41.6328 89.6611 43.3369 100.453 42.8692 111.169C42.0553 129.817 42.5236 147.224 60.6217 158.346C76.7812 168.276 97.1182 177.034 116.52 178.568C129.705 179.611 144.492 177.924 157.2 174.491C221.964 156.996 216.687 109.447 211.889 78.0463Z",
    fill: "#F4F7FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M156.711 118.574C145.357 119.388 135.938 110.7 135.938 99.1911C135.938 87.6823 145.357 78.0094 156.711 77.6361C167.826 77.2706 176.698 85.9873 176.698 97.06C176.698 108.133 167.826 117.777 156.711 118.574Z",
    fill: "url(#paint0_linear_297_60)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M158.096 119.035C146.741 119.849 137.322 111.161 137.322 99.652C137.322 88.1431 146.741 78.4703 158.096 78.097C169.211 77.7315 178.082 86.4483 178.082 97.5209C178.082 108.594 169.211 118.238 158.096 119.035Z",
    fill: "url(#paint1_linear_297_60)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M176.728 97.5923C176.728 107.931 168.468 116.894 158.096 117.624C147.515 118.368 138.781 110.294 138.781 99.5764C138.781 88.8587 147.515 79.8713 158.096 79.5093C168.468 79.1543 176.728 87.2532 176.728 97.5923Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_297_60",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 140,
    y: 80,
    width: 36,
    height: 37
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M175.37 97.6638C175.37 107.25 167.706 115.549 158.095 116.213C148.306 116.888 140.235 109.411 140.235 99.5007C140.235 89.5904 148.306 81.2695 158.095 80.9214C167.706 80.5797 175.37 88.078 175.37 97.6638Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_297_60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.815 85.4737C152.456 85.5905 149.268 87.6653 147.853 90.3516C146.149 93.5882 148.425 95.001 147.313 100.151C146.289 104.895 143.899 105.848 144.294 108.892C144.726 112.228 147.993 114.153 149.284 114.914C155.091 118.337 164.167 117.606 168.777 112.416C169.162 111.982 172.344 108.4 171.485 105.345C170.717 102.612 167.421 102.804 166.739 99.9572C166.151 97.5048 168.402 96.5546 168.188 92.9585C168.146 92.2549 167.948 88.9246 165.442 87.5435C163.774 86.6239 161.941 87.0388 161.269 87.2268C160.463 86.6351 158.499 85.3804 155.815 85.4737Z",
    fill: "url(#paint2_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.781 112.673C138.781 112.673 155.75 101.675 176.728 110.226C176.728 110.226 174.056 118.879 158.096 120.462C141.637 122.094 138.781 112.673 138.781 112.673Z",
    fill: "url(#paint3_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.089 98.7236L154.453 103.499C154.236 105.129 153.123 106.551 151.576 107.173L146.403 109.252C146.403 109.252 156.303 113.392 168.806 107.823L163.106 106.198C161.488 105.692 160.385 104.229 160.315 102.491L160.151 98.459L155.089 98.7236Z",
    fill: "url(#paint4_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.803 94.142C162.803 98.1392 160.398 102.569 157.415 102.736C154.415 102.905 151.971 98.7037 151.971 94.6653C151.971 90.6269 154.415 88.3143 157.415 88.1871C160.398 88.0605 162.803 90.1448 162.803 94.142Z",
    fill: "url(#paint5_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.801 90.6712C158.181 90.8282 155.727 91.3304 154.027 93.1976C151.174 96.3326 152.529 101.005 151.259 101.355C150.128 101.667 148.377 98.3824 148.405 94.6728C148.429 91.566 149.491 87.8584 152.255 86.8224C153.878 86.2139 154.356 87.0725 159.591 87.3679C162.641 87.5401 161.444 88.9616 162.13 89.4416C165.176 91.5728 164.791 99.0489 163.151 99.2311C162.374 99.3176 161.3 97.4257 159.801 90.6712Z",
    fill: "url(#paint6_linear_297_60)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M193.752 78.5939C182.135 78.964 172.5 69.5322 172.5 57.5619C172.5 45.5914 182.135 35.9198 193.752 36.0005C205.129 36.0796 214.213 45.5183 214.213 57.0425C214.213 68.5666 205.129 78.2315 193.752 78.5939Z",
    fill: "url(#paint7_linear_297_60)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M195.216 78.5939C183.599 78.964 173.964 69.5322 173.964 57.5619C173.964 45.5914 183.599 35.9198 195.216 36.0005C206.593 36.0796 215.676 45.5183 215.676 57.0425C215.676 68.5666 206.593 78.2315 195.216 78.5939Z",
    fill: "url(#paint8_linear_297_60)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M214.29 57.0596C214.29 67.8199 205.833 76.801 195.216 77.125C184.39 77.4554 175.456 68.6909 175.456 57.5431C175.456 46.3953 184.39 37.4083 195.216 37.4691C205.833 37.5286 214.29 46.2991 214.29 57.0596Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_297_60",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 176,
    y: 38,
    width: 37,
    height: 38
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M212.9 57.0767C212.9 67.0529 205.054 75.3691 195.217 75.6561C185.2 75.9484 176.944 67.8327 176.944 57.5244C176.944 47.2161 185.2 38.8948 195.217 38.9377C205.054 38.9797 212.9 47.1005 212.9 57.0767Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_297_60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.456 71.2136C175.456 71.2136 192.816 60.4814 214.29 70.255C214.29 70.255 211.554 79.1485 195.216 80.1258C178.378 81.133 175.456 71.2136 175.456 71.2136Z",
    fill: "url(#paint9_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.139 57.334L191.488 62.276C191.299 65.4177 188.25 66.6605 188.25 66.6605C191.83 70.9074 198.674 70.5846 201.067 66.4316C199.414 65.8389 197.559 63.2827 197.487 61.4717L197.32 57.2695L192.139 57.334Z",
    fill: "url(#paint10_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.035 52.8885C200.035 57.0477 197.572 61.5564 194.52 61.6063C191.45 61.6566 188.949 57.1838 188.949 52.9825C188.949 48.7811 191.45 46.4767 194.52 46.4688C197.572 46.4608 200.035 48.7294 200.035 52.8885Z",
    fill: "url(#paint11_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.784 54.0435C189.091 53.9914 189.398 53.9393 189.704 53.8872C189.563 53.5445 188.982 52.0267 189.704 50.689C190.397 49.4054 192.029 48.7733 193.275 48.8515C194.69 48.9402 195.539 49.5995 196.249 49.0819C196.648 48.791 196.777 48.2657 196.823 47.8569C196.854 48.1182 196.926 48.5046 197.109 48.931C197.637 50.1559 198.53 50.4063 199.017 51.2149C199.344 51.7592 199.557 52.6726 199.017 54.2885C199.286 54.2696 199.556 54.2507 199.825 54.2319C200.11 53.3248 200.451 52.039 200.663 50.4673C200.978 48.1338 201.194 46.5276 200.3 45.748C200.122 45.5927 199.334 44.9768 197.448 45.5612C197.006 45.0938 196.074 44.2383 194.641 43.8075C194.145 43.6585 191.685 42.9191 189.503 44.5223C188.019 45.6128 186.856 47.6459 187.23 49.324C187.427 50.2113 187.968 50.6077 188.444 52.3226C188.645 53.0466 188.738 53.6564 188.784 54.0435Z",
    fill: "url(#paint12_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.269 54.4307C199.269 54.4307 199.623 52.6054 200.698 52.777C201.771 52.9483 200.233 55.9476 199.269 56.3176V54.4307Z",
    fill: "url(#paint13_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.64 54.5251C189.64 54.5251 189.279 52.6896 188.181 52.8812C187.082 53.0731 188.656 56.0775 189.64 56.4287V54.5251Z",
    fill: "url(#paint14_linear_297_60)"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M211.274 114.179C202.378 114.463 195 107.24 195 98.0738C195 88.9073 202.378 81.5011 211.274 81.5629C219.986 81.6235 226.942 88.8513 226.942 97.6761C226.942 106.501 219.986 113.902 211.274 114.179Z",
    fill: "url(#paint15_linear_297_60)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M212.395 114.179C203.499 114.463 196.121 107.24 196.121 98.0738C196.121 88.9073 203.499 81.5011 212.395 81.5629C221.108 81.6235 228.063 88.8513 228.063 97.6761C228.063 106.501 221.108 113.902 212.395 114.179Z",
    fill: "url(#paint16_linear_297_60)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M227.001 97.6895C227.001 105.929 220.525 112.807 212.396 113.055C204.105 113.308 197.264 106.596 197.264 98.0597C197.264 89.5231 204.105 82.6412 212.396 82.6877C220.525 82.7333 227.001 89.4495 227.001 97.6895Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_297_60",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 198,
    y: 83,
    width: 28,
    height: 29
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M225.937 97.7029C225.937 105.342 219.929 111.711 212.396 111.93C204.725 112.154 198.403 105.939 198.403 98.0457C198.403 90.1519 204.725 83.7798 212.396 83.8126C219.929 83.8448 225.937 90.0634 225.937 97.7029Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_297_60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.264 108.529C197.264 108.529 210.557 100.31 227.001 107.795C227.001 107.795 224.906 114.605 212.396 115.353C199.501 116.125 197.264 108.529 197.264 108.529Z",
    fill: "url(#paint17_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.039 97.901L209.541 101.685C209.396 104.091 207.061 105.043 207.061 105.043C209.803 108.295 215.043 108.048 216.876 104.868C215.61 104.414 214.19 102.456 214.135 101.069L214.007 97.8516L210.039 97.901Z",
    fill: "url(#paint18_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.085 94.4961C216.085 97.681 214.2 101.134 211.862 101.172C209.511 101.21 207.596 97.7853 207.596 94.5681C207.596 91.3508 209.511 89.5862 211.862 89.5801C214.2 89.574 216.085 91.3112 216.085 94.4961Z",
    fill: "url(#paint19_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.47 95.3804C207.705 95.3404 207.94 95.3005 208.175 95.2607C208.067 94.9983 207.621 93.8359 208.175 92.8116C208.705 91.8287 209.955 91.3446 210.909 91.4045C211.992 91.4724 212.643 91.9773 213.186 91.5809C213.492 91.3582 213.591 90.9559 213.626 90.6429C213.65 90.8429 213.704 91.1388 213.845 91.4654C214.249 92.4034 214.933 92.5951 215.306 93.2143C215.556 93.6311 215.719 94.3306 215.306 95.568C215.512 95.5535 215.719 95.539 215.925 95.5246C216.143 94.83 216.404 93.8454 216.566 92.6418C216.807 90.8549 216.973 89.6249 216.289 89.028C216.152 88.909 215.549 88.4374 214.104 88.8849C213.766 88.527 213.052 87.8719 211.955 87.542C211.575 87.4279 209.691 86.8617 208.02 88.0894C206.884 88.9244 205.993 90.4813 206.28 91.7663C206.431 92.4458 206.845 92.7493 207.21 94.0625C207.363 94.617 207.434 95.0839 207.47 95.3804Z",
    fill: "url(#paint20_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.498 95.6754C215.498 95.6754 215.769 94.2777 216.592 94.4091C217.414 94.5403 216.237 96.8371 215.498 97.1204V95.6754Z",
    fill: "url(#paint21_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.125 95.7501C208.125 95.7501 207.849 94.3445 207.008 94.4912C206.166 94.6382 207.372 96.9388 208.125 97.2077V95.7501Z",
    fill: "url(#paint22_linear_297_60)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3994 181.117C77.5029 181.4 70.125 174.178 70.125 165.011C70.125 155.845 77.5029 148.439 86.3994 148.5C95.1114 148.561 102.067 155.789 102.067 164.614C102.067 173.438 95.1115 180.839 86.3994 181.117Z",
    fill: "url(#paint23_linear_297_60)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5205 181.117C78.624 181.4 71.2461 174.178 71.2461 165.011C71.2461 155.845 78.624 148.439 87.5205 148.5C96.2325 148.561 103.188 155.789 103.188 164.614C103.188 173.438 96.2325 180.839 87.5205 181.117Z",
    fill: "url(#paint24_linear_297_60)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M102.126 164.627C102.126 172.867 95.6504 179.744 87.5205 179.992C79.2302 180.245 72.3887 173.534 72.3887 164.997C72.3887 156.461 79.2302 149.579 87.5205 149.625C95.6504 149.671 102.126 156.387 102.126 164.627Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_297_60",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 150,
    width: 29,
    height: 29
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M101.062 164.64C101.062 172.28 95.0536 178.648 87.5206 178.868C79.8501 179.092 73.5283 172.877 73.5283 164.983C73.5283 157.089 79.8501 150.717 87.5206 150.75C95.0536 150.782 101.062 157.001 101.062 164.64Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_297_60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.3887 175.466C72.3887 175.466 85.6824 167.248 102.126 174.732C102.126 174.732 100.031 181.542 87.5205 182.291C74.6259 183.062 72.3887 175.466 72.3887 175.466Z",
    fill: "url(#paint25_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1642 164.838L84.6659 168.623C84.5212 171.029 82.186 171.98 82.186 171.98C84.9276 175.232 90.1685 174.985 92.0012 171.805C90.7347 171.351 89.3149 169.394 89.2596 168.007L89.1315 164.789L85.1642 164.838Z",
    fill: "url(#paint26_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2103 161.434C91.2103 164.619 89.3248 168.071 86.9871 168.109C84.6364 168.148 82.7212 164.723 82.7212 161.506C82.7212 158.288 84.6364 156.524 86.9871 156.518C89.3248 156.511 91.2103 158.249 91.2103 161.434Z",
    fill: "url(#paint27_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5946 162.318C82.8298 162.278 83.0647 162.238 83.2996 162.198C83.1917 161.936 82.7464 160.773 83.2996 159.749C83.8304 158.766 85.08 158.282 86.034 158.342C87.1175 158.41 87.7677 158.915 88.3113 158.518C88.6169 158.296 88.7157 157.893 88.7507 157.58C88.7748 157.78 88.8295 158.076 88.9702 158.403C89.3744 159.341 90.0583 159.533 90.4307 160.152C90.6813 160.569 90.8443 161.268 90.4307 162.505C90.6371 162.491 90.8435 162.477 91.0498 162.462C91.2676 161.767 91.5288 160.783 91.6912 159.579C91.9323 157.792 92.0983 156.562 91.4136 155.965C91.2771 155.847 90.6737 155.375 89.2291 155.822C88.8907 155.464 88.1774 154.809 87.0796 154.479C86.6998 154.365 84.816 153.799 83.1454 155.027C82.0091 155.862 81.1183 157.419 81.4046 158.704C81.556 159.383 81.9702 159.687 82.3346 161C82.4884 161.554 82.5592 162.021 82.5946 162.318Z",
    fill: "url(#paint28_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.623 162.613C90.623 162.613 90.8942 161.215 91.7174 161.347C92.539 161.478 91.3615 163.775 90.623 164.058V162.613Z",
    fill: "url(#paint29_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2499 162.688C83.2499 162.688 82.9738 161.282 82.1332 161.429C81.291 161.576 82.497 163.876 83.2499 164.145V162.688Z",
    fill: "url(#paint30_linear_297_60)"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M131.399 188.992C122.503 189.275 115.125 182.053 115.125 172.886C115.125 163.72 122.503 156.314 131.399 156.375C140.111 156.436 147.067 163.664 147.067 172.489C147.067 181.313 140.111 188.714 131.399 188.992Z",
    fill: "url(#paint31_linear_297_60)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M132.52 188.992C123.624 189.275 116.246 182.053 116.246 172.886C116.246 163.72 123.624 156.314 132.52 156.375C141.233 156.436 148.188 163.664 148.188 172.489C148.188 181.313 141.233 188.714 132.52 188.992Z",
    fill: "url(#paint32_linear_297_60)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M147.126 172.502C147.126 180.742 140.65 187.619 132.521 187.867C124.23 188.12 117.389 181.409 117.389 172.872C117.389 164.336 124.23 157.454 132.521 157.5C140.65 157.546 147.126 164.262 147.126 172.502Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_297_60",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 158,
    width: 29,
    height: 29
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M146.062 172.515C146.062 180.155 140.054 186.523 132.521 186.743C124.85 186.967 118.528 180.752 118.528 172.858C118.528 164.964 124.85 158.592 132.521 158.625C140.054 158.657 146.062 164.876 146.062 172.515Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_297_60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.389 183.341C117.389 183.341 130.682 175.123 147.126 182.607C147.126 182.607 145.031 189.417 132.521 190.166C119.626 190.937 117.389 183.341 117.389 183.341Z",
    fill: "url(#paint33_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.164 172.713L129.666 176.498C129.521 178.904 127.186 179.855 127.186 179.855C129.928 183.107 135.168 182.86 137.001 179.68C135.735 179.226 134.315 177.269 134.26 175.882L134.132 172.664L130.164 172.713Z",
    fill: "url(#paint34_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.21 169.309C136.21 172.494 134.325 175.946 131.987 175.984C129.636 176.023 127.721 172.598 127.721 169.381C127.721 166.163 129.636 164.399 131.987 164.393C134.325 164.386 136.21 166.124 136.21 169.309Z",
    fill: "url(#paint35_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.595 170.193C127.83 170.153 128.065 170.113 128.3 170.073C128.192 169.811 127.746 168.648 128.3 167.624C128.83 166.641 130.08 166.157 131.034 166.217C132.117 166.285 132.768 166.79 133.311 166.393C133.617 166.171 133.716 165.768 133.751 165.455C133.775 165.655 133.829 165.951 133.97 166.278C134.374 167.216 135.058 167.408 135.431 168.027C135.681 168.444 135.844 169.143 135.431 170.38C135.637 170.366 135.844 170.352 136.05 170.337C136.268 169.642 136.529 168.658 136.691 167.454C136.932 165.667 137.098 164.437 136.414 163.84C136.277 163.722 135.674 163.25 134.229 163.697C133.891 163.339 133.177 162.684 132.08 162.354C131.7 162.24 129.816 161.674 128.145 162.902C127.009 163.737 126.118 165.294 126.405 166.579C126.556 167.258 126.97 167.562 127.335 168.875C127.488 169.429 127.559 169.896 127.595 170.193Z",
    fill: "url(#paint36_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.623 170.488C135.623 170.488 135.894 169.09 136.717 169.222C137.539 169.353 136.362 171.65 135.623 171.933V170.488Z",
    fill: "url(#paint37_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.25 170.563C128.25 170.563 127.974 169.157 127.133 169.304C126.291 169.451 127.497 171.751 128.25 172.02V170.563Z",
    fill: "url(#paint38_linear_297_60)"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M169.649 179.992C160.753 180.275 153.375 173.053 153.375 163.886C153.375 154.72 160.753 147.314 169.649 147.375C178.361 147.436 185.317 154.664 185.317 163.489C185.317 172.313 178.361 179.714 169.649 179.992Z",
    fill: "url(#paint39_linear_297_60)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M170.77 179.992C161.874 180.275 154.496 173.053 154.496 163.886C154.496 154.72 161.874 147.314 170.77 147.375C179.483 147.436 186.438 154.664 186.438 163.489C186.438 172.313 179.483 179.714 170.77 179.992Z",
    fill: "url(#paint40_linear_297_60)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M185.376 163.502C185.376 171.742 178.9 178.619 170.771 178.867C162.48 179.12 155.639 172.409 155.639 163.872C155.639 155.336 162.48 148.454 170.771 148.5C178.9 148.546 185.376 155.262 185.376 163.502Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_297_60",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 156,
    y: 149,
    width: 29,
    height: 29
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M184.312 163.515C184.312 171.155 178.304 177.523 170.771 177.743C163.1 177.967 156.778 171.752 156.778 163.858C156.778 155.964 163.1 149.592 170.771 149.625C178.304 149.657 184.312 155.876 184.312 163.515Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_297_60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.639 174.341C155.639 174.341 168.932 166.123 185.376 173.607C185.376 173.607 183.281 180.417 170.771 181.166C157.876 181.937 155.639 174.341 155.639 174.341Z",
    fill: "url(#paint41_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.414 163.713L167.916 167.498C167.771 169.904 165.436 170.855 165.436 170.855C168.178 174.107 173.418 173.86 175.251 170.68C173.985 170.226 172.565 168.269 172.51 166.882L172.382 163.664L168.414 163.713Z",
    fill: "url(#paint42_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.46 160.309C174.46 163.494 172.575 166.946 170.237 166.984C167.886 167.023 165.971 163.598 165.971 160.381C165.971 157.163 167.886 155.399 170.237 155.393C172.575 155.386 174.46 157.124 174.46 160.309Z",
    fill: "url(#paint43_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.845 161.193C166.08 161.153 166.315 161.113 166.55 161.073C166.442 160.811 165.996 159.648 166.55 158.624C167.08 157.641 168.33 157.157 169.284 157.217C170.367 157.285 171.018 157.79 171.561 157.393C171.867 157.171 171.966 156.768 172.001 156.455C172.025 156.655 172.079 156.951 172.22 157.278C172.624 158.216 173.308 158.408 173.681 159.027C173.931 159.444 174.094 160.143 173.681 161.38C173.887 161.366 174.094 161.352 174.3 161.337C174.518 160.642 174.779 159.658 174.941 158.454C175.182 156.667 175.348 155.437 174.664 154.84C174.527 154.722 173.924 154.25 172.479 154.697C172.141 154.339 171.427 153.684 170.33 153.354C169.95 153.24 168.066 152.674 166.395 153.902C165.259 154.737 164.368 156.294 164.655 157.579C164.806 158.258 165.22 158.562 165.585 159.875C165.738 160.429 165.809 160.896 165.845 161.193Z",
    fill: "url(#paint44_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.873 161.488C173.873 161.488 174.144 160.09 174.967 160.222C175.789 160.353 174.612 162.65 173.873 162.933V161.488Z",
    fill: "url(#paint45_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.5 161.563C166.5 161.563 166.224 160.157 165.383 160.304C164.541 160.451 165.747 162.751 166.5 163.02V161.563Z",
    fill: "url(#paint46_linear_297_60)"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M193.274 148.492C184.378 148.775 177 141.553 177 132.386C177 123.22 184.378 115.814 193.274 115.875C201.986 115.936 208.942 123.164 208.942 131.989C208.942 140.813 201.986 148.214 193.274 148.492Z",
    fill: "url(#paint47_linear_297_60)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M194.395 148.492C185.499 148.775 178.121 141.553 178.121 132.386C178.121 123.22 185.499 115.814 194.395 115.875C203.108 115.936 210.063 123.164 210.063 131.989C210.063 140.813 203.108 148.214 194.395 148.492Z",
    fill: "url(#paint48_linear_297_60)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M209.001 132.002C209.001 140.242 202.525 147.119 194.396 147.367C186.105 147.62 179.264 140.909 179.264 132.372C179.264 123.836 186.105 116.954 194.396 117C202.525 117.046 209.001 123.762 209.001 132.002Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_297_60",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 180,
    y: 118,
    width: 28,
    height: 29
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M207.937 132.015C207.937 139.655 201.929 146.023 194.396 146.243C186.725 146.467 180.403 140.252 180.403 132.358C180.403 124.464 186.725 118.092 194.396 118.125C201.929 118.157 207.937 124.376 207.937 132.015Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_297_60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.264 142.841C179.264 142.841 192.557 134.623 209.001 142.107C209.001 142.107 206.906 148.917 194.396 149.666C181.501 150.437 179.264 142.841 179.264 142.841Z",
    fill: "url(#paint49_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.039 132.213L191.541 135.998C191.396 138.404 189.061 139.355 189.061 139.355C191.803 142.607 197.043 142.36 198.876 139.18C197.61 138.726 196.19 136.769 196.135 135.382L196.007 132.164L192.039 132.213Z",
    fill: "url(#paint50_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.085 128.809C198.085 131.994 196.2 135.446 193.862 135.484C191.511 135.523 189.596 132.098 189.596 128.881C189.596 125.663 191.511 123.899 193.862 123.893C196.2 123.886 198.085 125.624 198.085 128.809Z",
    fill: "url(#paint51_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.47 129.693C189.705 129.653 189.94 129.613 190.175 129.573C190.067 129.311 189.621 128.148 190.175 127.124C190.705 126.141 191.955 125.657 192.909 125.717C193.992 125.785 194.643 126.29 195.186 125.893C195.492 125.671 195.591 125.268 195.626 124.955C195.65 125.155 195.704 125.451 195.845 125.778C196.249 126.716 196.933 126.908 197.306 127.527C197.556 127.944 197.719 128.643 197.306 129.88C197.512 129.866 197.719 129.852 197.925 129.837C198.143 129.142 198.404 128.158 198.566 126.954C198.807 125.167 198.973 123.937 198.289 123.34C198.152 123.222 197.549 122.75 196.104 123.197C195.766 122.839 195.052 122.184 193.955 121.854C193.575 121.74 191.691 121.174 190.02 122.402C188.884 123.237 187.993 124.794 188.28 126.079C188.431 126.758 188.845 127.062 189.21 128.375C189.363 128.929 189.434 129.396 189.47 129.693Z",
    fill: "url(#paint52_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.498 129.988C197.498 129.988 197.769 128.59 198.592 128.722C199.414 128.853 198.237 131.15 197.498 131.433V129.988Z",
    fill: "url(#paint53_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.125 130.063C190.125 130.063 189.849 128.657 189.008 128.804C188.166 128.951 189.372 131.251 190.125 131.52V130.063Z",
    fill: "url(#paint54_linear_297_60)"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8994 55.1169C37.0029 55.4003 29.625 48.1778 29.625 39.0113C29.625 29.8448 37.0029 22.4386 45.8994 22.5004C54.6114 22.561 61.567 29.7888 61.567 38.6136C61.5671 47.4384 54.6115 54.8394 45.8994 55.1169Z",
    fill: "url(#paint55_linear_297_60)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0205 55.1169C38.124 55.4003 30.7461 48.1778 30.7461 39.0113C30.7461 29.8448 38.124 22.4386 47.0205 22.5004C55.7325 22.561 62.6881 29.7888 62.6881 38.6136C62.6881 47.4384 55.7325 54.8394 47.0205 55.1169Z",
    fill: "url(#paint56_linear_297_60)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6264 38.627C61.6264 46.8669 55.1504 53.7443 47.0205 53.9924C38.7302 54.2454 31.8887 47.5338 31.8887 38.9972C31.8887 30.4606 38.7302 23.5787 47.0205 23.6252C55.1504 23.6708 61.6264 30.387 61.6264 38.627Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_297_60",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 24,
    width: 28,
    height: 29
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M60.562 38.6404C60.562 46.2798 54.5536 52.648 47.0206 52.8678C39.3501 53.0917 33.0283 46.8769 33.0283 38.9832C33.0283 31.0894 39.3501 24.7173 47.0206 24.7501C54.5536 24.7823 60.562 31.0009 60.562 38.6404Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_297_60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.8887 49.4662C31.8887 49.4662 45.1824 41.2478 61.6264 48.7321C61.6264 48.7321 59.5312 55.5424 47.0205 56.2908C34.1259 57.0621 31.8887 49.4662 31.8887 49.4662Z",
    fill: "url(#paint57_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6642 38.8385L44.1659 42.6229C44.0212 45.0286 41.686 45.9803 41.686 45.9803C44.4276 49.2324 49.6685 48.9852 51.5012 45.805C50.2347 45.3512 48.8149 43.3938 48.7596 42.007L48.6315 38.7891L44.6642 38.8385Z",
    fill: "url(#paint58_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7103 35.4336C50.7103 38.6185 48.8248 42.0711 46.4871 42.1094C44.1364 42.1479 42.2212 38.7228 42.2212 35.5056C42.2212 32.2883 44.1364 30.5237 46.4871 30.5176C48.8248 30.5115 50.7103 32.2487 50.7103 35.4336Z",
    fill: "url(#paint59_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0946 36.3179C42.3298 36.2779 42.5647 36.238 42.7996 36.1982C42.6917 35.9358 42.2464 34.7734 42.7996 33.7491C43.3304 32.7662 44.58 32.2821 45.534 32.342C46.6175 32.4099 47.2677 32.9148 47.8113 32.5184C48.1169 32.2957 48.2157 31.8934 48.2507 31.5804C48.2748 31.7804 48.3295 32.0763 48.4702 32.4029C48.8744 33.3409 49.5583 33.5326 49.9307 34.1518C50.1813 34.5686 50.3443 35.2681 49.9307 36.5055C50.1371 36.491 50.3435 36.4765 50.5498 36.4621C50.7676 35.7675 51.0288 34.7829 51.1912 33.5793C51.4323 31.7924 51.5983 30.5624 50.9136 29.9655C50.7771 29.8465 50.1737 29.3749 48.7291 29.8224C48.3907 29.4645 47.6774 28.8094 46.5796 28.4795C46.1998 28.3654 44.316 27.7992 42.6454 29.0269C41.5091 29.8619 40.6183 31.4188 40.9046 32.7038C41.056 33.3833 41.4702 33.6868 41.8346 35C41.9884 35.5545 42.0592 36.0214 42.0946 36.3179Z",
    fill: "url(#paint60_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.123 36.6129C50.123 36.6129 50.3942 35.2152 51.2174 35.3466C52.039 35.4778 50.8615 37.7746 50.123 38.0579V36.6129Z",
    fill: "url(#paint61_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7499 36.6876C42.7499 36.6876 42.4738 35.282 41.6332 35.4287C40.791 35.5757 41.997 37.8763 42.7499 38.1452V36.6876Z",
    fill: "url(#paint62_linear_297_60)"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3994 47.8044C77.5029 48.0878 70.125 40.8653 70.125 31.6988C70.125 22.5323 77.5029 15.1261 86.3994 15.1879C95.1114 15.2485 102.067 22.4763 102.067 31.3011C102.067 40.1259 95.1115 47.5269 86.3994 47.8044Z",
    fill: "url(#paint63_linear_297_60)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5205 47.8044C78.624 48.0878 71.2461 40.8653 71.2461 31.6988C71.2461 22.5323 78.624 15.1261 87.5205 15.1879C96.2325 15.2485 103.188 22.4763 103.188 31.3011C103.188 40.1259 96.2325 47.5269 87.5205 47.8044Z",
    fill: "url(#paint64_linear_297_60)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M102.126 31.3145C102.126 39.5544 95.6504 46.4318 87.5205 46.6799C79.2302 46.9329 72.3887 40.2213 72.3887 31.6847C72.3887 23.1481 79.2302 16.2662 87.5205 16.3127C95.6504 16.3583 102.126 23.0745 102.126 31.3145Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_297_60",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 17,
    width: 29,
    height: 29
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M101.062 31.3279C101.062 38.9673 95.0536 45.3355 87.5206 45.5553C79.8501 45.7792 73.5283 39.5644 73.5283 31.6707C73.5283 23.7769 79.8501 17.4048 87.5206 17.4376C95.0536 17.4698 101.062 23.6884 101.062 31.3279Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_297_60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.3887 42.1537C72.3887 42.1537 85.6824 33.9353 102.126 41.4196C102.126 41.4196 100.031 48.2299 87.5205 48.9783C74.6259 49.7496 72.3887 42.1537 72.3887 42.1537Z",
    fill: "url(#paint65_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1642 31.526L84.6659 35.3104C84.5212 37.7161 82.186 38.6678 82.186 38.6678C84.9276 41.9199 90.1685 41.6727 92.0012 38.4925C90.7347 38.0387 89.3149 36.0813 89.2596 34.6945L89.1315 31.4766L85.1642 31.526Z",
    fill: "url(#paint66_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2103 28.1211C91.2103 31.306 89.3248 34.7586 86.9871 34.7969C84.6364 34.8354 82.7212 31.4103 82.7212 28.1931C82.7212 24.9758 84.6364 23.2112 86.9871 23.2051C89.3248 23.199 91.2103 24.9362 91.2103 28.1211Z",
    fill: "url(#paint67_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5946 29.0054C82.8298 28.9654 83.0647 28.9255 83.2996 28.8857C83.1917 28.6233 82.7464 27.4609 83.2996 26.4366C83.8304 25.4537 85.08 24.9696 86.034 25.0295C87.1175 25.0974 87.7677 25.6023 88.3113 25.2059C88.6169 24.9832 88.7157 24.5809 88.7507 24.2679C88.7748 24.4679 88.8295 24.7638 88.9702 25.0904C89.3744 26.0284 90.0583 26.2201 90.4307 26.8393C90.6813 27.2561 90.8443 27.9556 90.4307 29.193C90.6371 29.1785 90.8435 29.164 91.0498 29.1496C91.2676 28.455 91.5288 27.4704 91.6912 26.2668C91.9323 24.4799 92.0983 23.2499 91.4136 22.653C91.2771 22.534 90.6737 22.0624 89.2291 22.5099C88.8907 22.152 88.1774 21.4969 87.0796 21.167C86.6998 21.0529 84.816 20.4867 83.1454 21.7144C82.0091 22.5494 81.1183 24.1063 81.4046 25.3913C81.556 26.0708 81.9702 26.3743 82.3346 27.6875C82.4884 28.242 82.5592 28.7089 82.5946 29.0054Z",
    fill: "url(#paint68_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.623 29.3004C90.623 29.3004 90.8942 27.9027 91.7174 28.0341C92.539 28.1653 91.3615 30.4621 90.623 30.7454V29.3004Z",
    fill: "url(#paint69_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2499 29.3751C83.2499 29.3751 82.9738 27.9695 82.1332 28.1162C81.291 28.2632 82.497 30.5638 83.2499 30.8327V29.3751Z",
    fill: "url(#paint70_linear_297_60)"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M139.926 53.195C125.141 53.077 112.875 40.8187 112.875 25.8715C112.875 10.9243 125.141 -0.662279 139.926 0.0294282C154.398 0.706547 165.949 12.9454 165.949 27.3248C165.949 41.7041 154.398 53.3104 139.926 53.195Z",
    fill: "url(#paint71_linear_297_60)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M141.719 53.195C126.934 53.077 114.668 40.8187 114.668 25.8715C114.668 10.9243 126.934 -0.662279 141.719 0.0294282C156.191 0.706547 167.742 12.9454 167.742 27.3248C167.742 41.7041 156.191 53.3104 141.719 53.195Z",
    fill: "url(#paint72_linear_297_60)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M165.979 27.2757C165.979 40.7024 155.224 51.4867 141.719 51.3609C127.942 51.2326 116.568 39.8424 116.568 25.9227C116.568 12.003 127.942 1.2358 141.719 1.86192C155.224 2.47573 165.979 13.849 165.979 27.2757Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_297_60",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 3,
    width: 47,
    height: 47
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M164.211 27.2286C164.211 39.677 154.233 49.6622 141.719 49.5289C128.971 49.3931 118.462 38.847 118.462 25.9759C118.462 13.1048 128.971 3.13424 141.719 3.69649C154.233 4.24846 164.211 14.7801 164.211 27.2286Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_297_60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.369 42.9626C122.039 39.1033 127.034 37.7869 127.67 28.8051C127.714 28.1952 128.56 15.927 130.446 13.5698C130.697 13.2565 130.977 13.0084 130.977 13.0084C131.92 12.2775 133.378 12.363 138.581 10.1925C143.04 8.33233 142.782 8.38599 143.358 8.28006C146.71 7.66397 151.666 10.7324 153.297 14.8268C154.76 18.4989 153.005 21.6339 155.627 28.0879L155.627 28.0882C158.878 37.3748 160.503 42.0181 159.032 44.9338C154.561 53.7952 126.356 51.6255 123.369 42.9626Z",
    fill: "url(#paint73_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.568 42.9333C116.568 42.9333 138.664 30.4072 165.979 43.6838C165.979 43.6838 162.5 54.6445 141.719 55.0484C120.287 55.465 116.568 42.9333 116.568 42.9333Z",
    fill: "url(#paint74_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.803 26.5059L136.975 32.6421C136.693 34.7359 135.244 36.4673 133.229 37.115L126.494 39.2796C126.494 39.2796 139.384 45.6809 155.664 39.7436L148.242 37.0429C146.136 36.2177 144.7 34.2038 144.608 31.9398L144.395 26.6864L137.803 26.5059Z",
    fill: "url(#paint75_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.849 21.3539C147.849 26.545 144.717 32.0485 140.833 31.9573C136.926 31.8657 133.744 26.1563 133.744 20.9116C133.744 15.6668 136.926 12.9167 140.833 13.0621C144.716 13.2069 147.849 16.1629 147.849 21.3539Z",
    fill: "url(#paint76_linear_297_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.508 24.2864C134.181 24.2693 133.209 18.7948 135.818 17.3567C137.55 16.402 140.556 17.3985 142.246 19.2245C144.91 22.1025 143.42 26.0947 145.438 27.0081C146.719 27.5879 148.429 26.4772 149.248 25.653C151.807 23.0792 151.458 17.4743 148.433 14.2281C146.022 11.6403 142.75 11.4474 141.972 11.4255C137.517 11.2997 133.427 14.4812 132.489 18.3509C131.768 21.3249 133.01 24.2991 133.508 24.2864Z",
    fill: "url(#paint77_linear_297_60)"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2635 90.0621V102.29H34.7223V107.942H23.2635V120.17H17.6111V107.942H6.15234V102.29H17.6111V90.0621H23.2635ZM58.0243 128.783C55.5634 128.783 53.064 128.425 50.5261 127.707C48.0139 126.963 45.899 126.117 44.1815 125.169L44.22 115.248L48.2574 114.787L50.257 122.208C51.5643 122.695 52.9102 123.093 54.2944 123.4C55.7043 123.682 57.1143 123.823 58.5242 123.823C61.3184 123.823 63.6383 122.887 65.484 121.016C67.3297 119.145 68.2526 116.607 68.2526 113.403C68.2526 110.121 67.3041 107.519 65.4071 105.597C63.5101 103.649 61.0876 102.674 58.1396 102.674H54.1791V97.7141H57.7551C60.4468 97.7141 62.5616 96.9066 64.0997 95.2916C65.6378 93.6766 66.4069 91.3951 66.4069 88.4471C66.4069 85.6017 65.7019 83.4868 64.292 82.1025C62.8821 80.7183 60.7159 80.0261 57.7936 80.0261C56.64 80.0261 55.4993 80.1415 54.3713 80.3722C53.269 80.6029 52.2437 80.8977 51.2952 81.2566L49.2572 88.6779L45.2197 88.2164V77.9113C47.45 76.9628 49.7186 76.2578 52.0258 75.7964C54.3329 75.3093 56.6144 75.0658 58.8702 75.0658C63.587 75.0658 67.24 76.1425 69.8291 78.2958C72.4182 80.4235 73.7128 83.4996 73.7128 87.5243C73.7128 90.4979 73.0078 93.0101 71.5979 95.0609C70.188 97.0861 68.4192 98.6498 66.2915 99.7521C69.1626 100.649 71.4185 102.226 73.0591 104.482C74.6997 106.712 75.52 109.339 75.52 112.364C75.52 117.491 73.9307 121.516 70.752 124.438C67.5732 127.335 63.3307 128.783 58.0243 128.783ZM100.552 128.783C94.7333 128.783 90.4138 127.053 87.594 123.592C84.7742 120.106 83.3643 114.928 83.3643 108.058V104.02C83.3643 94.5098 84.9792 87.3064 88.2092 82.4102C91.4648 77.5139 96.0535 75.0658 101.975 75.0658C108.076 75.0658 112.575 76.7577 115.472 80.1415C118.369 83.4996 119.817 88.7291 119.817 95.83V99.829C119.817 109.493 118.279 116.735 115.203 121.554C112.152 126.374 107.269 128.783 100.552 128.783ZM112.357 97.8679C112.357 91.7668 111.537 87.2679 109.896 84.3712C108.281 81.4745 105.513 80.0261 101.591 80.0261C97.7197 80.0261 94.9512 81.6539 93.2849 84.9095C91.6443 88.1395 90.824 93.3562 90.824 100.56V105.943C90.824 112.018 91.6827 116.517 93.4003 119.44C95.1178 122.362 97.8223 123.823 101.514 123.823C105.513 123.823 108.32 122.118 109.935 118.709C111.55 115.3 112.357 110.147 112.357 103.251V97.8679Z",
    fill: "#662D91"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_297_60",
    x1: 135.938,
    y1: 98.1258,
    x2: 176.698,
    y2: 98.1258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_297_60",
    x1: 137.322,
    y1: 98.5868,
    x2: 178.082,
    y2: 98.5868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#602A88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_297_60",
    x1: 164.268,
    y1: 84.6233,
    x2: 158.634,
    y2: 102.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_297_60",
    x1: 138.781,
    y1: 113.811,
    x2: 176.728,
    y2: 113.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662D91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_297_60",
    x1: 157.561,
    y1: 100.116,
    x2: 157.634,
    y2: 114.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_297_60",
    x1: 159.57,
    y1: 79.7377,
    x2: 156.305,
    y2: 101.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_297_60",
    x1: 160.156,
    y1: 83.1991,
    x2: 154.336,
    y2: 101.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_297_60",
    x1: 172.5,
    y1: 57.3022,
    x2: 214.213,
    y2: 57.3022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_297_60",
    x1: 173.964,
    y1: 57.3022,
    x2: 215.676,
    y2: 57.3022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662D91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_297_60",
    x1: 175.456,
    y1: 73.172,
    x2: 214.29,
    y2: 73.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_297_60",
    x1: 194.62,
    y1: 58.9499,
    x2: 194.694,
    y2: 73.3168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_297_60",
    x1: 196.736,
    y1: 39.1312,
    x2: 193.109,
    y2: 61.5282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_297_60",
    x1: 194.83,
    y1: 43.7722,
    x2: 193.055,
    y2: 54.7351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_297_60",
    x1: 202.411,
    y1: 40.0637,
    x2: 198.796,
    y2: 62.3892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_297_60",
    x1: 191.414,
    y1: 38.2711,
    x2: 187.78,
    y2: 60.7122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_297_60",
    x1: 195,
    y1: 97.875,
    x2: 226.942,
    y2: 97.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_297_60",
    x1: 196.121,
    y1: 97.875,
    x2: 228.063,
    y2: 97.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662D91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_297_60",
    x1: 197.264,
    y1: 110.028,
    x2: 227.001,
    y2: 110.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_297_60",
    x1: 211.939,
    y1: 99.1384,
    x2: 211.995,
    y2: 110.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_297_60",
    x1: 213.559,
    y1: 83.9613,
    x2: 210.782,
    y2: 101.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_297_60",
    x1: 212.1,
    y1: 87.515,
    x2: 210.741,
    y2: 95.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_297_60",
    x1: 217.905,
    y1: 84.6737,
    x2: 215.136,
    y2: 101.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_297_60",
    x1: 209.484,
    y1: 83.3033,
    x2: 206.701,
    y2: 100.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_297_60",
    x1: 70.125,
    y1: 164.812,
    x2: 102.067,
    y2: 164.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_297_60",
    x1: 71.2461,
    y1: 164.812,
    x2: 103.188,
    y2: 164.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662D91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_297_60",
    x1: 72.3887,
    y1: 176.966,
    x2: 102.126,
    y2: 176.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_297_60",
    x1: 87.0637,
    y1: 166.076,
    x2: 87.1204,
    y2: 177.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_297_60",
    x1: 88.6841,
    y1: 150.899,
    x2: 85.9069,
    y2: 168.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_297_60",
    x1: 87.2249,
    y1: 154.452,
    x2: 85.8655,
    y2: 162.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_297_60",
    x1: 93.0298,
    y1: 151.611,
    x2: 90.2615,
    y2: 168.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_297_60",
    x1: 84.6087,
    y1: 150.241,
    x2: 81.826,
    y2: 167.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_297_60",
    x1: 115.125,
    y1: 172.687,
    x2: 147.067,
    y2: 172.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_297_60",
    x1: 116.246,
    y1: 172.687,
    x2: 148.188,
    y2: 172.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662D91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_297_60",
    x1: 117.389,
    y1: 184.841,
    x2: 147.126,
    y2: 184.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_297_60",
    x1: 132.064,
    y1: 173.951,
    x2: 132.12,
    y2: 184.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_297_60",
    x1: 133.684,
    y1: 158.774,
    x2: 130.907,
    y2: 175.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_297_60",
    x1: 132.225,
    y1: 162.327,
    x2: 130.866,
    y2: 170.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_297_60",
    x1: 138.03,
    y1: 159.486,
    x2: 135.261,
    y2: 176.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_297_60",
    x1: 129.609,
    y1: 158.116,
    x2: 126.826,
    y2: 175.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_297_60",
    x1: 153.375,
    y1: 163.687,
    x2: 185.317,
    y2: 163.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_297_60",
    x1: 154.496,
    y1: 163.687,
    x2: 186.438,
    y2: 163.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662D91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_297_60",
    x1: 155.639,
    y1: 175.841,
    x2: 185.376,
    y2: 175.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_297_60",
    x1: 170.314,
    y1: 164.951,
    x2: 170.37,
    y2: 175.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_297_60",
    x1: 171.934,
    y1: 149.774,
    x2: 169.157,
    y2: 166.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_297_60",
    x1: 170.475,
    y1: 153.327,
    x2: 169.116,
    y2: 161.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_297_60",
    x1: 176.28,
    y1: 150.486,
    x2: 173.511,
    y2: 167.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_297_60",
    x1: 167.859,
    y1: 149.116,
    x2: 165.076,
    y2: 166.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_297_60",
    x1: 177,
    y1: 132.187,
    x2: 208.942,
    y2: 132.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_297_60",
    x1: 178.121,
    y1: 132.187,
    x2: 210.063,
    y2: 132.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662D91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_297_60",
    x1: 179.264,
    y1: 144.341,
    x2: 209.001,
    y2: 144.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_297_60",
    x1: 193.939,
    y1: 133.451,
    x2: 193.995,
    y2: 144.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_297_60",
    x1: 195.559,
    y1: 118.274,
    x2: 192.782,
    y2: 135.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_297_60",
    x1: 194.1,
    y1: 121.827,
    x2: 192.741,
    y2: 130.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_297_60",
    x1: 199.905,
    y1: 118.986,
    x2: 197.136,
    y2: 136.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_297_60",
    x1: 191.484,
    y1: 117.616,
    x2: 188.701,
    y2: 134.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_297_60",
    x1: 29.625,
    y1: 38.8125,
    x2: 61.567,
    y2: 38.8125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_297_60",
    x1: 30.7461,
    y1: 38.8125,
    x2: 62.6881,
    y2: 38.8125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662D91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_297_60",
    x1: 31.8887,
    y1: 50.9659,
    x2: 61.6264,
    y2: 50.9659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_297_60",
    x1: 46.5637,
    y1: 40.0759,
    x2: 46.6204,
    y2: 51.0775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_297_60",
    x1: 48.1841,
    y1: 24.8988,
    x2: 45.4069,
    y2: 42.0496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_297_60",
    x1: 46.7249,
    y1: 28.4525,
    x2: 45.3655,
    y2: 36.8475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_297_60",
    x1: 52.5298,
    y1: 25.6112,
    x2: 49.7615,
    y2: 42.7073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_297_60",
    x1: 44.1087,
    y1: 24.2408,
    x2: 41.326,
    y2: 41.4254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_297_60",
    x1: 70.125,
    y1: 31.5,
    x2: 102.067,
    y2: 31.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_297_60",
    x1: 71.2461,
    y1: 31.5,
    x2: 103.188,
    y2: 31.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662D91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_297_60",
    x1: 72.3887,
    y1: 43.6534,
    x2: 102.126,
    y2: 43.6534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_297_60",
    x1: 87.0637,
    y1: 32.7634,
    x2: 87.1204,
    y2: 43.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_297_60",
    x1: 88.6841,
    y1: 17.5863,
    x2: 85.9069,
    y2: 34.7371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_297_60",
    x1: 87.2249,
    y1: 21.14,
    x2: 85.8655,
    y2: 29.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_297_60",
    x1: 93.0298,
    y1: 18.2987,
    x2: 90.2615,
    y2: 35.3948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_297_60",
    x1: 84.6087,
    y1: 16.9283,
    x2: 81.826,
    y2: 34.1129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_297_60",
    x1: 112.875,
    y1: 26.5979,
    x2: 165.949,
    y2: 26.5979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_297_60",
    x1: 114.668,
    y1: 26.5979,
    x2: 167.742,
    y2: 26.5979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662D91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_297_60",
    x1: 174.301,
    y1: -26.7799,
    x2: 111.423,
    y2: 92.2997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_297_60",
    x1: 141.298,
    y1: 42.8747,
    x2: 138.907,
    y2: 85.6013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_297_60",
    x1: 141.023,
    y1: 28.6072,
    x2: 141.117,
    y2: 46.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_297_60",
    x1: 143.605,
    y1: 2.25835,
    x2: 139.397,
    y2: 30.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_297_60",
    x1: 153.74,
    y1: -2.39259,
    x2: 129.919,
    y2: 42.7198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg30Users);
export default __webpack_public_path__ + "static/media/30_users.d0fb19f7d11f422e9fe617fdf177d9e7.svg";
export { ForwardRef as ReactComponent };